import { questionGenerator } from '@/data/generators/questionGenerator';
import { PositionalItem } from '@/models/Answer';
import { FlowColumn } from '@/models/Question';
import {
  DnDColumnType,
  DNDPositionalQuestion,
  PositionalColumn,
  QuestionTypeEnum,
} from '@/models/Question';

export function positionalItemGenerator(
  item?: Partial<PositionalItem>,
): PositionalItem {
  return {
    id: 1,
    text: 'Item A',
    altText: '',
    mediaFile: null,
    order: 1,
    validPositions: [],
    dndPositionalColumn: 1,
    ...item,
  };
}

export function positionalColumnGenerator(
  column?: Partial<PositionalColumn>,
): PositionalColumn {
  return {
    id: 1,
    name: 'Perguntas',
    flow: FlowColumn.VERTICAL,
    type: DnDColumnType.QUESTION,
    items: [],
    ...column,
  };
}

export function positionalQuestionGenerator(
  question?: Partial<DNDPositionalQuestion>,
): DNDPositionalQuestion {
  const questionColumn =
    question?.questionColumn ??
    positionalColumnGenerator({ id: 1, type: DnDColumnType.QUESTION });
  const answerColumn =
    question?.answerColumn ??
    positionalColumnGenerator({
      id: 2,
      name: 'Respostas',
      type: DnDColumnType.ANSWER,
    });

  return {
    ...questionGenerator(question),
    questionColumn,
    answerColumn,
    ...question,
    type: QuestionTypeEnum.DND_POSITIONAL,
  };
}
